import { registerComponent } from '@gig/magic-common';
import BoxComponent from './box.vue.js';

var Box = registerComponent(BoxComponent);

export { Box };
